export default {
    meta: {
        title: '修改成功',
        isShowHeader: false,
    },
};
